import Cookies from 'js-cookie';
import { isProduction } from "@config/config";

const ACCESS_TOKEN_COOKIE_NAME = 'access_token';
const REFRESH_TOKEN_COOKIE_NAME = 'refresh_token';

export const getAccessToken = () => Cookies.get(ACCESS_TOKEN_COOKIE_NAME);
export const getRefreshToken = () => Cookies.get(REFRESH_TOKEN_COOKIE_NAME);

export const setAccessToken = (access_token) => {
  Cookies.set(ACCESS_TOKEN_COOKIE_NAME, access_token, { 
      expires: 1,
      secure: isProduction(), 
      sameSite: 'Strict'
  });
}

export const setRefreshToken = (refresh_token) => {
  Cookies.set(REFRESH_TOKEN_COOKIE_NAME, refresh_token, { 
      expires: 1,
      secure: isProduction(), 
      sameSite: 'Strict'
  });
}

export const removeAccessToken = () => {
  Cookies.remove(ACCESS_TOKEN_COOKIE_NAME);
}

export const removeRefreshToken = () => {
  Cookies.remove(REFRESH_TOKEN_COOKIE_NAME);
}

export const removeToken = () => {
  removeAccessToken();
  removeRefreshToken();
}